/**
 * Pipe-detection debug logging. Toggle `PIPE_DEBUG` to silence. Logs are
 * prefixed with `[pipe]` and timestamped relative to a run start so the user
 * can paste a full detection trace back for diagnosis.
 *
 * Set `window.__PIPE_DEBUG__ = false` at runtime to turn off without a rebuild.
 */

const DEFAULT_ON = true;

const isOn = (): boolean => {
  if (typeof window !== 'undefined' && (window as any).__PIPE_DEBUG__ !== undefined) {
    return !!(window as any).__PIPE_DEBUG__;
  }
  return DEFAULT_ON;
};

export function dbg(...args: unknown[]): void {
  if (isOn()) console.log('[pipe]', ...args);
}

export function dbgWarn(...args: unknown[]): void {
  if (isOn()) console.warn('[pipe]', ...args);
}

/** Small stopwatch for phase timings. */
export class Stopwatch {
  private t0 = performance.now();
  private last = this.t0;
  lap(label: string): number {
    const now = performance.now();
    const delta = now - this.last;
    this.last = now;
    if (isOn()) console.log(`[pipe] ⏱ ${label}: ${delta.toFixed(0)}ms (total ${(now - this.t0).toFixed(0)}ms)`);
    return delta;
  }
  total(): number {
    return performance.now() - this.t0;
  }
}
